module.exports = __webpack_public_path__ + "media/images/smart_phone/delivery_status_notifications/top_b_h-adb0b8728a73c66fd69220f02dfc04b6.png";